<template>
    <div class="col-md-6" >
            <label class="attribute-label m-bottom-12"> Tip Tax ({{ tip.tip_tax.tax_percent}}%)</label>

            <div class="input-group width-100">
                <input type="text" class="form-control disabled price-new-inputs" :value="tip.tip_tax.tax_value" disabled readonly/>
                <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
            </div>

    </div>
</template>

<script>
export default {
    name: "BookingTipTax",
    props: [
        'tip', // it will be an object with the surcharge and the percentage
        'currency'
    ],
}
</script>

<style scoped>

</style>